import React from "react";
import { TableCell, FormControl, Select, MenuItem } from "@mui/material";

const DropdownCell = ({
  value,
  onChange,
  options = [],
  rowId,
  field,
  style = {},
  disabled = false,
  menuStyle = {},
  valueStyles = {},
}) => {
  // console.log("value", value);
  // console.log("options", options);
  // console.log("field", field);
  //   console.log(" DropdownCell rowId", rowId);
  return (
    <TableCell
      style={{
        padding: "8px",
        borderBottom: "1px solid #ddd",
        ...style,
      }}
    >
      <FormControl fullWidth>
        <Select
          value={value || ""} // Default to an empty string if no value
          onChange={(e) => onChange(rowId, field, e.target.value)} // Pass rowId, field, and selected value
          displayEmpty
          disabled={disabled}
          style={{
            backgroundColor: valueStyles[value]?.backgroundColor || "white",
            color: valueStyles[value]?.color || "black",
            opacity: disabled ? 0.5 : 1, // ✅ visual feedback
            pointerEvents: disabled ? "none" : "auto", // ✅ prevent clicks
          }}
          MenuProps={{
            PaperProps: {
              style: {
                fontWeight: "bold",
                color: "#FFFFFF",

                cursor: "pointer",
                backgroundColor: "#2E4053",
                ...menuStyle,
              },
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </TableCell>
  );
};

export default DropdownCell;
